module.exports = __webpack_public_path__ + "img/check-circle-solid_icon.76311efc.svg";